import { Subject } from "rxjs";
import { InitSessionResponse } from "./PaymentService";

/* eslint-disable @typescript-eslint/no-namespace */
declare namespace OneInc {
  class PortalOne {
    constructor(container: HTMLDivElement, callback: () => void);
    run(options: { sessionId: string; accessTokenId: string }): void;
  }
}

/**
 * @description Class for
 * Rendering portal one modal
 * And teardown modal (removing handlers placed on container element)
 * Emitting portal one modal events
 */
class PortalOneModalService {
  private _PAYMENT_COMPLETE_EVENT = "portalOne.paymentComplete";
  private _UNLOAD_EVENT = "portalOne.unload";
  private paymentComplete = (e: Event) => this.paymentComplete$.next(e);
  private unload = () => {
    this.clearListeners();
  };

  paymentComplete$ = new Subject<Event>();
  modalLoadError$ = new Subject<any>();
  containerId: string | null = null;
  container: HTMLDivElement | null = null;

  constructor(containerId: string) {
    this.containerId = containerId;
  }

  renderModal(sessionPayload: InitSessionResponse) {
    const { sessionId, accessToken } = sessionPayload;
    this.container = document.getElementById(
      this.containerId as string,
    ) as HTMLDivElement;

    const subscribeToOneIncEvents = () => {
      this.container?.addEventListener(
        this._PAYMENT_COMPLETE_EVENT,
        this.paymentComplete,
      );

      this.container?.addEventListener(this._UNLOAD_EVENT, this.unload);
    };

    try {
      const portalOne = new OneInc.PortalOne(
        this.container,
        subscribeToOneIncEvents,
      );
      portalOne.run({ sessionId, accessTokenId: accessToken });
    } catch (e) {
      this.modalLoadError$.next(e);
    }
  }

  clearListeners() {
    this.container?.removeEventListener(
      this._PAYMENT_COMPLETE_EVENT,
      this.paymentComplete,
    );

    this.container?.removeEventListener(this._UNLOAD_EVENT, this.unload);
    this.container = null;
  }
}

export default PortalOneModalService;
